import SettingsTemplatesList from './list'


if (document.body.getAttribute("data-current-path") === "settings/templates") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new SettingsTemplatesList();
    }
}